import SwissPostQuery from "../query/SwissPost.query";
import { createRef } from 'react';

const getStreetFields = (args, callback) => {
    const streetFields = callback(...args);
    const [props] = args;
    streetFields[0].type = 'suggestions';
    streetFields[0].suggestionsConfig = {
        suggestionsDataKey: 'autocompleteStreet',
        suggestionsQuery: SwissPostQuery.getAutocompleteStreetQuery,
        suggestionsMinLength: 3,
        isEnabled: props.countryId === 'CH'
    };

    return streetFields;
}

const cityRef = createRef('');
const zipRef = createRef('');

const myAccountAddressForm = (args, callback) => {
    const addressFields = callback(...args);
    const [props] = args;
    const addressGroupFields = addressFields.find(af => af.name === 'addressGroup').fields;

    const postcodeField = addressGroupFields.find(agf => agf.attr.name === 'postcode');
    postcodeField.type = 'suggestions';
    postcodeField.elemRef = zipRef;
    postcodeField.suggestionsConfig = {
        suggestionsDataKey: 'autocompleteZip',
        suggestionsQuery: SwissPostQuery.getAutocompleteZipQuery,
        suggestionsOptionValueKey: 'zip',
        suggestionsOptionLabel: (item) => `${item.zip} ${item.city27}`,
        suggestionsOptionLinkedValueField: 'city',
        suggestionsOptionLinkedValueRef: cityRef,
        suggestionsOptionLinkedValueKey: 'city27',
        isEnabled: props.countryId === 'CH'
    };

    const cityField = addressGroupFields.find(agf => agf.attr.name === 'city');
    cityField.type = 'suggestions';
    cityField.elemRef = cityRef;
    cityField.suggestionsConfig = {
        suggestionsDataKey: 'autocompleteZip',
        suggestionsQuery: SwissPostQuery.getAutocompleteZipQuery,
        suggestionsOptionValueKey: 'city27',
        suggestionsOptionLabel: (item) => `${item.zip} ${item.city27}`,
        suggestionsOptionLinkedValueField: 'postcode',
        suggestionsOptionLinkedValueRef: zipRef,
        suggestionsOptionLinkedValueKey: 'zip',
        isEnabled: props.countryId === 'CH'
    };

    return addressFields;
}

export default {
    'Component/MyAccountAddressForm/Form/getStreetFields': {
        function: getStreetFields
    },
    'Component/MyAccountAddressForm/Form/myAccountAddressForm': {
        function: myAccountAddressForm
    }
}
